<template>
    <el-card>
        <div slot="header">
            <span class="top_title">{{(editMode==1?'编辑':'新增')+title}}</span>
        </div>
        <div class="searchItem">
            <div class="search" v-if="editMode==1">
                <span class="searchtips">单号:</span>
                <span>{{number}}</span>
            </div>
            <div class="search"  v-if="isPurchase<=2">
                <span class="searchtips"><span style="color: #F56C6C;margin-right: 4px;">*</span>供应商:</span>
                <el-select v-model="supply" style="width:160px" @change="changeSelect($event,1)">
                    <el-option v-for="item in supplyList" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="search">
                <span class="searchtips"><span style="color: #F56C6C;margin-right: 4px;">*</span>仓库:</span>
                <el-select v-model="mwid" clearable style="width:160px" @change="changeSelect($event,2)">
                    <el-option v-for="item in listWare" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
            </div>
            <Customer :hideStar="true" :orderForm="searchDate" v-if="isPurchase==1"></Customer>
            <div class="search" v-if="isPurchase==1">
                <span class="searchtips">商品:</span>
                <el-select
                    ref="editCell"
                    style="width:180px;"
                    v-model="pid"
                    filterable
                    remote
                    value-key="id"
                    :remote-method="remoteMethod"
                    clearable
                >
                    <el-option
                        v-for="item in pList"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="searchItem" v-if="isPurchase==1&&editMode==0">
            <div class="search">
                <span class="searchtips">状态:</span>
                <el-radio-group v-model="radio">
                    <el-radio :label="1">待审核</el-radio>
                    <el-radio :label="2">审核通过</el-radio>
                </el-radio-group>
            </div>
        </div>
        <SPTable ref="spt" :cols='cols' :structure="structure" @returnData="saveEnter" :productModel="false" :wareHouseModel="false" :mproductModel="true"></SPTable>
        <div class="searchItem" style="padding-top:20px">
            <div class="search">
                <span class="searchtips" style="line-height:60px">备注:</span>
                <el-input
                    v-model="remark"
                    type="textarea"
                    maxlength="100"
                    style="width: 480px;font-size:14px"
                />
            </div>
        </div>
        <div class="searchItem" v-if="isPurchase<=2">
            <div class="search">
                <span class="searchtips">付款账户</span>
                <el-tag v-for="item in caList" :key="item.id" style="margin-right:10px;cursor: pointer;" :effect="item.show?'dark':'plain'" @click="item.show=!item.show">{{item.name}}</el-tag>
            </div>
        </div>
        <div class="searchItem" v-if="isPurchase<=2">
            <div class="search">
                <span class="searchtips">付款</span>
                <span v-if="tagOne">总付款金额:{{tagNum}}</span>
                <span v-else>请选择付款账户</span>
            </div>
        </div>
        <div class="searchItem" v-if="isPurchase<=2">
            <div class="search" v-for="item in caList" :key="item.id" v-show="item.show">
                <span class="searchtips">{{item.name}}</span>
                <el-input v-model="item.num" @input="$common.checkMoney($event,item,'num')" style="width:160px"></el-input>
            </div>
        </div>
        <div class="search" v-if="isPurchase<=1">
            <span class="searchtips">优惠金额</span>
            <el-input v-model="freeObj.free" @input="$common.checkMoney($event,freeObj.free)" style="width:160px"></el-input>
        </div>
        <div style="margin-top:20px;display:flex;justify-content: center;">
            <el-button type="primary" @click="submit" :loading="lock">确认</el-button>
        </div>
    </el-card>
</template>

<script>
import Customer from '../../components/customer.vue';
import SPTable from '../../components/table-column/supertable';
export default {
    components:{
        Customer,
        SPTable,
    },
    data(){
        return{
            searchDate: {
                cid:'',
                cname:'',
            },
            pid:'',
            supply:'',
            mwid:'',
            freeObj:{
                free:0,
            },
            freekey:'',
            remark:"",
            number:"",
            time:this.$common.format(new Date()),
            supplyList:[],
            listWare:[],
            pList:[],
            caList:[],
            radio:1,
            cols: [
                {
                    prop: "name",
                    label: "产品",
                    edit:'mproductEdit',
                    type: "mproductEdit",
                    width: 240,
                },
                {
                    prop: "stocknum",
                    label: "库存",
                    edit:'',
                    type: "",
                    width: 130,
                    hide:false,
                },
                {
                    prop: "price",
                    label: "开价单价(元)",
                    edit:'priceEdit',
                    type: "priceEdit",
                    width: 130,
                },
                {
                    prop: "count",
                    label: "数量",
                    edit:'countEdit',
                    type: "unknowNumEdit",
                    width: 130,
                },
                {
                    prop: "tprice",
                    label: "总价(元)",
                    edit:'',
                    type: "tpriceEdit",
                    width: 130,
                    cal1:'price',
                    cal2:'count',
                },
                {
                    prop: "remark",
                    label: "备注",
                    edit:'remarkEdit',
                    type: "remarkEdit",
                    min_width: 200,
                    align: "center",
                },
            ],
            lock:false,
            editMode:0,
            orderid:0,
            title:'采购单',
            isPurchase:1,
            baseNum:'/material/order/generateNum',
        }
    },
    created(){
        let id = this.$route.query.id;
        this.orderid = id;
        if(this.orderid>0){
            this.editMode = 1;
            this.cols[1].hide = true;//退货单库存隐藏
        }
        let arr = [
        {
            str:"/material/supply/listSupply",
            func:(res)=>{
                if(res.data.code==1){
                    res.data.data.data.forEach(e => {
                        let obj = {
                            id:e.id,
                            label:"["+e.number+"]"+e.name,
                        }
                        this.supplyList.push(obj);
                    });
                }
            }
        },{
            str:"/material/ware/listWare",
            func:(res)=>{
                if(res.data.code==1){
                    res.data.data.data.forEach(e => {
                        let obj = {
                            id:e.id,
                            label:e.name,
                        }
                        this.listWare.push(obj);
                    });
                }
            }
        },{
            str:"/mobile/company/getCompanyAccount",
            func:(res)=>{
                if(res.data.code==1){
                    res.data.data.forEach(e=>{
                        let obj = {
                            id:e.id,
                            name:e.name,
                            show:false,
                            num:0,
                            spkey:'',
                        }
                        this.caList.push(obj);
                    });
                }
            }
        }];
        this.$api.getInfoByPost(arr,()=>{
            if(this.editMode==1&&this.orderid>0){
                this.initEdit();
            }
        });
        if(this.isPurchase==1){
            this.remoteMethod();
        }
    },
    methods: {
        structure(){
            let obj = {
                id:0,
                pid: '',
                spid:'',
                price: 0,
                count: 0,
                name:'',
                tprice:'',
                remark:'',
                inter:0,
                stocknum:0,
                mproductEdit:false,
                countEdit:false,
                remarkEdit:false,
                priceEdit:false,
            }
            return obj;
        },
        initEdit(){
            this.$api.mOrderDetail({id:this.orderid}).then(res=>{
                if(res.data.code==1){
                    let info = res.data.data;
                    this.searchDate.cid = info.cid;
                    this.searchDate.cname = info.cname;
                    this.pid = info.pid;
                    this.supply = info.supply;
                    if(this.supply>0){
                        this.$refs.spt.getMProduct(this.supply);
                    }
                    this.mwid = info.wid;
                    this.freeObj.free = info.freeSum;
                    this.remark = info.remark;
                    this.number = info.number;
                    this.time = info.cdate;
                    this.$refs.spt.setData(info.detail,(o,e)=>{
                        o.spkey = e.id,
                        o.pid = e.mid;
                        o.spid = e.msid;
                        o.price = e.price;
                        o.count = e.amount;
                        o.name = e.mnumber +' ' +e.mname+"_"+e.mspec1+"_"+e.mspec2;
                        o.tprice = e.money;
                        o.remark = e.remark;
                        o.unit = e.packing;
                        o.inter = e.inter;
                        o.stocknum = e.stocknum;
                    })
                    info.pays.forEach(e=>{
                        if(e.type==1){
                            for(let i in this.caList){
                                let temp = this.caList[i];
                                if(temp.id==e.accountId&&e.money>0){
                                    temp.show = true;
                                    temp.num = e.money;
                                    temp.spkey = e.id;
                                }
                            }
                        }else if(e.type==2){
                            this.freekey = e.id;
                        }
                    })
                }
            })
        },
        changeSelect(val,type){
            if(val>0){
                if(this.isPurchase<=2&&type==1){
                    this.$refs.spt.setMProduct(val,1);
                }else if(this.isPurchase>2&&type==2){
                    this.$refs.spt.setMProduct(val,2);
                }
            }
        },
        remoteMethod(val){
            let obj = {}
            if(val!=null){
                obj.product = val;
            }
            this.pList = [];
            this.$api.listProduct(obj).then((res)=>{
                if(res.data.code==1){
                    let data = res.data.data;
                    data.forEach(e=>{
                        let temp = {
                            id:e.id,
                            value:e.name,
                        }
                        this.pList.push(temp);
                    })
                }
            })
        },
        submit(){
            this.$refs.spt.getData();
        },
        saveEnter(formData){
            if(this.mwid>0){}else{
                this.$common.error('没有选择仓库');
                return;
            }
            if(this.isPurchase<=2){
                if(this.supply>0){}else{
                    this.$common.error('没有选择供应商');
                    return;
                }
            }
           
            this.lock = true;
            if(this.editMode==0){
                this.$api.getInfoPostSingle(this.baseNum).then(res=>{
                    if(res.data.code==1){
                        this.number = res.data.data;
                        this.fixObj(formData);
                    }else{
                        this.lock = false;
                    }
                })
            }else{
                this.fixObj(formData);
            }
        },
        fixObj(formData){
            let obj = {
                number:this.number,
                date:this.time,
                remark:this.remark,
                mwid:this.mwid,
            }
            if(this.isPurchase<=2){
                obj.supply=this.supply;
                obj.pid=this.pid;
                obj.cid=this.searchDate.cid;
                obj.state=this.radio;
                let pay = [];
                for(let i in this.caList){
                    let com = this.caList[i];
                    if(com.show&&com.num>0){
                        let obj1 = {
                            type:1,
                            way:com.name,
                            money:com.num,
                            accountId:com.id,
                        }
                        if(com.spkey>0){
                            obj1.id = com.spkey;
                        }
                        pay.push(obj1);
                    }
                }
                if(this.freeObj.free>0){
                    obj.free = this.freeObj.free;
                    let obj1 = {
                        type:2,
                        way:'优惠金额',
                        money:this.freeObj.free,
                    }
                    if(this.freekey){
                        obj1.id = this.freekey;
                    }
                    pay.push(obj1);
                }
                obj.pay = JSON.stringify(pay);
            }else if(this.isPurchase==3){
                obj.eid = this.$global.id;
            }
            let detail = [];
            formData.forEach(e=>{
                if(e.pid>0&&e.count>0){
                    let obj1={
                        mid:e.pid,
                        msid:e.spid,
                        price:e.price,
                        amount:e.count,
                        remark:e.remark,
                    }
                    if(e.spkey>0){
                        obj1.id = e.spkey;
                    }
                    detail.push(obj1);
                }
            })
            if(detail.length>0){
                if(this.isPurchase<=2){
					obj.detail = JSON.stringify(detail);
				}else{
					obj.data = JSON.stringify(detail);
				}
                this.checkend(obj);
            }else{
                this.$common.error('没有产品');
                this.lock = false;
            }
        },
        checkend(obj){

        }
    },
    computed:{
        tagOne:function(){
            for(let i in this.caList){
                if(this.caList[i].show){
                    return true;
                }
            }
            return false;
        },
        tagNum:function(){
            let num = 0;
            for(let i in this.caList){
                if(this.caList[i].show){
                    num+=parseFloat(this.caList[i].num);
                }
            }
            return parseFloat(num).toFixed(2);
        }
    }
}
</script>

<style scoped>
</style>